import { useState } from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { PasswordField } from '@components/password-field';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

export const RemoveAuthenticator = observer(({ disable, remove, closeModal }) => {
  const { t } = useStore();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function onSubmit() {
    const res = await remove(password);
    if (res.error) {
      setError(res.data.device);
    } else {
      disable();
      closeModal();
    }
  }
  return (
    <Modal>
      <Modal.Header text={t('modals.removeauthenticator.header')} />
      <Stack space={4}>
        <Text text={t('modals.removeauthenticator.subheader')} />
        <PasswordField
          label={t('modals.removeauthenticator.label.password')}
          value={password}
          onChange={setPassword}
          error={error && error.split('\n').map((item, i) => <div key={i}>{item}</div>)}
        />
      </Stack>

      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          text={t('modals.removeauthenticator.button.cancel')}
        />
        <Button
          variant="primary-red"
          onClick={onSubmit}
          text={t('modals.removeauthenticator.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
});
